export default __webpack_public_path__ + "static/media/medium.01553a16.PNG";